const pdfStyles = `
  <style>
    div[outputclass="tgl_blueBox"] {
        background: #d9f1f3;
        color: #414042;
        padding: 10px 40px;
        margin-bottom: 10px;
        font-size: 14px;
      }
        ph[outputclass="tgl_recorank"] {
        width: 25px;
        font-weight: 700;
        height: 25px;
        border-radius: 40px;
        font-size: 14px;
        color: #000;
        line-height: 24px;
        text-align: center;
        text-decoration: none;
        text-shadow: 0 1px 0 #fff;
        background: #fff;
        float: left;
        font-family: "DINNeuzeitGrotesk-Light", sans-serif;
        padding-right: 0px;
        margin-right: 10px;
        margin-left: -30px;
    }
      section[id="#section-undefined"] {
        display: none !important;
      }

    @media print {
      div[outputclass="tgl_blueBox"] {
        background: #d9f1f3 !important;
        color: #414042 !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        color-adjust: exact !important;
        margin: 5px !important;
      }
      ph[outputclass="tgl_recorank"] {
        width: 25px;
        height: 25px;
        border-radius: 40px !important;
        font-size: 14px;
        color: #000;
        line-height: 24px;
        text-align: center;
        text-decoration: none;
        text-shadow: 0 1px 0 #fff;
        background: #fff;
      }

      fn:not([fn-type="margin-note"]) {
        display: block !important;
        background: #e6e6e6 !important;
        font-family: "FranklinGothicITCbyBT-Book", Helvetica, sans-serif !important;
      }
    
    }
  </style>
`;

export default pdfStyles;